import React from "react";
import "../Styles/Components/Loader.scss";
function Loader() {
  return (
    <div className="container">
      <div className="loader" />
    </div>
  );
}

export default Loader;
